import { useQuery } from '@tanstack/react-query';

import { fetchTagEnrichment } from '../services/api/enrichments';

export const useTagEnrichment = (tagId?: string) => {
  return useQuery({
    queryKey: ['enrichment', tagId],
    queryFn: () => fetchTagEnrichment(tagId!),
    enabled: Boolean(tagId),
  });
};
